// import { useState, useEffect } from "react";
// import { HiMenu, HiX, HiChevronDown, HiChevronRight } from "react-icons/hi";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";
// import logo from "../../Assets/Logos/insd-logo.png";
// import { Link } from "react-router-dom";

// const UserNavbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(null);
//   const [desktopDropdown, setDesktopDropdown] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/courses/get-all`
//         );
//         if (response.data.success) {
//           setCourses(response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//         setCourses([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCourses();
//   }, []);

//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "unset";
//     }

//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, [isOpen]);

//   const navItems = [
//     { title: "Home", path: "/" },
//     { title: "About", path: "/about" },
//     {
//       title: "Courses",
//       isCourseDropdown: true,
//       isLoading: loading,
//     },
//     {
//       title: "Explore",
//       options: [
//         { title: "Events", path: "/events" },
//         { title: "Student Portfolios", path: "/student-portfolio" },
//       ],
//     },
//     {
//       title: "Updates",
//       options: [
//         { title: "Gallery", path: "/gallery" },
//         { title: "Blog & News", path: "/blog" },
//       ],
//     },
//     { title: "Contact", path: "/contact" },
//   ];

//   const slugify = (text) =>
//     text
//       .toString()
//       .toLowerCase()
//       .trim()
//       .replace(/\s+/g, "-")
//       .replace(/[^\w\-]+/g, "")
//       .replace(/\-\-+/g, "-");

//   const handleNavigation = (path, courseId = null) => {
//     if (courseId) {
//       navigate(path, { state: { courseId } });
//     } else {
//       navigate(path);
//     }
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     setIsOpen(false);
//     setDropdownOpen(null);
//     setDesktopDropdown(null);
//   };

//   const sidebarVariants = {
//     closed: {
//       x: "-100%",
//       transition: {
//         type: "spring",
//         stiffness: 400,
//         damping: 40,
//         duration: 0.3,
//       },
//     },
//     open: {
//       x: 0,
//       transition: {
//         type: "spring",
//         stiffness: 400,
//         damping: 40,
//         duration: 0.3,
//       },
//     },
//   };

//   const backdropVariants = {
//     closed: {
//       opacity: 0,
//       transition: {
//         duration: 0.2,
//       },
//     },
//     open: {
//       opacity: 1,
//       transition: {
//         duration: 0.2,
//       },
//     },
//   };

//   const menuItemVariants = {
//     closed: {
//       opacity: 0,
//       x: -20,
//       transition: {
//         duration: 0.2,
//       },
//     },
//     open: {
//       opacity: 1,
//       x: 0,
//       transition: {
//         duration: 0.3,
//       },
//     },
//   };

//   const dropdownVariants = {
//     closed: {
//       opacity: 0,
//       height: 0,
//       transition: {
//         duration: 0.2,
//       },
//     },
//     open: {
//       opacity: 1,
//       height: "auto",
//       transition: {
//         duration: 0.3,
//       },
//     },
//   };

//   const staggerContainer = {
//     open: {
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.1,
//       },
//     },
//     closed: {
//       transition: {
//         staggerChildren: 0.05,
//         staggerDirection: -1,
//       },
//     },
//   };

//   return (
//     <div className="sticky top-0 w-full z-50">
//       <nav className="bg-white shadow-lg w-full border-b border-gray-100 tracking-wide">
//         <div className="py-2 px-3 sm:px-4 md:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16 sm:h-18 md:h-20">
//             {/* Logo */}
//             <motion.div
//               className="flex-shrink-0 cursor-pointer transform hover:scale-105 transition-transform duration-200"
//               onClick={() => navigate("/")}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <img
//                 src={logo}
//                 alt="Logo"
//                 className="h-12 w-auto sm:h-14 md:h-16 lg:h-20 drop-shadow-sm"
//               />
//             </motion.div>

//             {/* Desktop Menu - Hidden on mobile/tablet */}
//             <div className="hidden lg:flex items-center space-x-1 xl:space-x-2">
//               {navItems.map((item, idx) =>
//                 item.options ? (
//                   <div
//                     key={idx}
//                     className="relative"
//                     onMouseEnter={() => setDesktopDropdown(idx)}
//                     onMouseLeave={() => setDesktopDropdown(null)}
//                   >
//                     <motion.button
//                       className="flex items-center px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
//                       whileHover={{ scale: 1.05 }}
//                       whileTap={{ scale: 0.95 }}
//                     >
//                       <span className="relative whitespace-nowrap">
//                         {item.title}
//                         <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
//                       </span>
//                       <HiChevronDown
//                         className={`ml-1 h-4 w-4 transition-transform duration-300 ${
//                           desktopDropdown === idx ? "rotate-180" : ""
//                         }`}
//                       />
//                     </motion.button>

//                     {/* Enhanced Dropdown */}
//                     <AnimatePresence>
//                       {desktopDropdown === idx && (
//                         <motion.div
//                           initial={{ opacity: 0, y: -10, scale: 0.95 }}
//                           animate={{ opacity: 1, y: 0, scale: 1 }}
//                           exit={{ opacity: 0, y: -10, scale: 0.95 }}
//                           transition={{ duration: 0.2 }}
//                           className="absolute top-full left-0 bg-white shadow-xl rounded-2xl mt-2 border border-gray-100 min-w-[200px] xl:min-w-[240px] z-20"
//                         >
//                           <div className="p-2 xl:p-3">
//                             {item.options.length > 0 ? (
//                               item.options.map((opt, i) => (
//                                 <motion.button
//                                   key={i}
//                                   onClick={() => handleNavigation(opt.path)}
//                                   className="flex justify-between items-center w-full text-left px-3 xl:px-4 py-2 xl:py-3 text-sm xl:text-base text-gray-600 hover:bg-primaryColor/5 hover:text-primaryColor rounded-xl transition-all duration-200 group"
//                                   whileHover={{ x: 4 }}
//                                   whileTap={{ scale: 0.98 }}
//                                 >
//                                   <span className="flex items-center font-medium whitespace-nowrap">
//                                     <span className="w-2 h-2 bg-primaryColor rounded-full mr-2 xl:mr-3 group-hover:scale-125 transition-transform duration-200"></span>
//                                     {opt.title}
//                                   </span>
//                                   <HiChevronRight className="h-4 w-4 text-gray-400 group-hover:text-primaryColor group-hover:translate-x-1 transition-all duration-200" />
//                                 </motion.button>
//                               ))
//                             ) : (
//                               <div className="px-4 py-3 text-gray-500 text-center text-sm">
//                                 No options available
//                               </div>
//                             )}
//                           </div>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </div>
//                 ) : item.isCourseDropdown ? (
//                   <div
//                     key={idx}
//                     className="relative"
//                     onMouseEnter={() => setDesktopDropdown(idx)}
//                     onMouseLeave={() => setDesktopDropdown(null)}
//                   >
//                     <motion.button
//                       className="flex items-center px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
//                       whileHover={{ scale: 1.05 }}
//                       whileTap={{ scale: 0.95 }}
//                     >
//                       <span className="relative whitespace-nowrap">
//                         {item.title}
//                         <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
//                       </span>
//                       <HiChevronDown
//                         className={`ml-1 h-4 w-4 transition-transform duration-300 ${
//                           desktopDropdown === idx ? "rotate-180" : ""
//                         }`}
//                       />
//                     </motion.button>

//                     {/* Courses Dropdown */}
//                     <AnimatePresence>
//                       {desktopDropdown === idx && (
//                         <motion.div
//                           initial={{ opacity: 0, y: -10, scale: 0.95 }}
//                           animate={{ opacity: 1, y: 0, scale: 1 }}
//                           exit={{ opacity: 0, y: -10, scale: 0.95 }}
//                           transition={{ duration: 0.2 }}
//                           className="absolute top-full left-0 bg-white shadow-xl rounded-2xl mt-2 border border-gray-100 min-w-[240px] xl:min-w-[280px] z-20 max-h-96 overflow-y-auto"
//                         >
//                           <div className="p-2 xl:p-3">
//                             {loading ? (
//                               <div className="px-4 py-3 text-gray-500 text-center text-sm">
//                                 Loading courses...
//                               </div>
//                             ) : courses.length > 0 ? (
//                               courses.map((course) => (
//                                 <motion.button
//                                   key={course._id}
//                                   onClick={() =>
//                                     handleNavigation(
//                                       `/courses/${slugify(course?.category)}`,
//                                       course._id
//                                     )
//                                   }
//                                   className="flex justify-between items-center w-full text-left px-3 xl:px-4 py-2 xl:py-3 text-gray-600 hover:bg-primaryColor/5 hover:text-primaryColor rounded-xl transition-all duration-200 group"
//                                   whileHover={{ x: 4 }}
//                                   whileTap={{ scale: 0.98 }}
//                                 >
//                                   <span className="flex items-center font-medium">
//                                     <span className="w-2 h-2 bg-primaryColor rounded-full mr-2 xl:mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-200"></span>
//                                     <span className="text-xs xl:text-sm break-words">
//                                       {course?.category}
//                                     </span>
//                                   </span>
//                                   <HiChevronRight className="h-4 w-4 text-gray-400 group-hover:text-primaryColor group-hover:translate-x-1 transition-all duration-200 flex-shrink-0 ml-2" />
//                                 </motion.button>
//                               ))
//                             ) : (
//                               <div className="px-4 py-3 text-gray-500 text-center text-sm">
//                                 No courses available
//                               </div>
//                             )}
//                           </div>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </div>
//                 ) : (
//                   <motion.button
//                     key={idx}
//                     className="relative px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
//                     onClick={() => handleNavigation(item.path)}
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <span className="relative whitespace-nowrap">
//                       {item.title}
//                       <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
//                     </span>
//                   </motion.button>
//                 )
//               )}
//             </div>

//             {/* CTA Button - Desktop only */}
//             <div className="hidden lg:block">
//               <motion.button
//                 className="bg-gradient-to-r from-primaryColor to-secondaryColor text-white px-4 xl:px-6 py-2 xl:py-3 rounded-xl hover:shadow-lg font-semibold shadow-md text-sm xl:text-base whitespace-nowrap heading"
//                 onClick={() => {
//                   navigate("/apply-online");
//                   window.scrollTo({ top: 0, behavior: "smooth" });
//                 }}
//                 whileHover={{
//                   scale: 1.05,
//                   y: -2,
//                   transition: { duration: 0.2 },
//                 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 Apply Online
//               </motion.button>
//             </div>

//             {/* Mobile menu button */}
//             <div className="lg:hidden flex items-center">
//               <motion.button
//                 onClick={() => setIsOpen(!isOpen)}
//                 className="focus:outline-none p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//               >
//                 {isOpen ? (
//                   <HiX className="h-6 w-6 text-gray-700" />
//                 ) : (
//                   <HiMenu className="h-6 w-6 text-gray-700" />
//                 )}
//               </motion.button>
//             </div>
//           </div>
//         </div>

//         {/* Mobile Sidebar with Animations */}
//         <AnimatePresence>
//           {isOpen && (
//             <>
//               {/* Backdrop */}
//               <motion.div
//                 key="backdrop"
//                 className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
//                 variants={backdropVariants}
//                 initial="closed"
//                 animate="open"
//                 exit="closed"
//                 onClick={() => setIsOpen(false)}
//               />

//               {/* Sidebar */}
//               <motion.div
//                 key="sidebar"
//                 className="lg:hidden fixed top-0 left-0 w-[85vw] max-w-[320px] sm:max-w-[360px] h-full bg-white shadow-2xl z-50 overflow-y-auto"
//                 variants={sidebarVariants}
//                 initial="closed"
//                 animate="open"
//                 exit="closed"
//               >
//                 <div className="p-4 sm:p-6">
//                   {/* Close Button */}
//                   <div className="flex justify-end mb-6 sm:mb-8">
//                     <motion.button
//                       onClick={() => setIsOpen(false)}
//                       className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
//                       whileHover={{ scale: 1.1 }}
//                       whileTap={{ scale: 0.9 }}
//                       variants={menuItemVariants}
//                     >
//                       <HiX className="h-5 w-5 text-gray-600" />
//                     </motion.button>
//                   </div>

//                   {/* Navigation Items */}
//                   <motion.div
//                     className="flex flex-col space-y-1 sm:space-y-2"
//                     variants={staggerContainer}
//                     initial="closed"
//                     animate="open"
//                     exit="closed"
//                   >
//                     {navItems.map((item, idx) =>
//                       item.isCourseDropdown ? (
//                         <motion.div
//                           key={idx}
//                           className="border-b border-gray-100 pb-2"
//                           variants={menuItemVariants}
//                         >
//                           <button
//                             className="flex justify-between items-center w-full py-3 sm:py-4 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 heading"
//                             onClick={() =>
//                               setDropdownOpen(dropdownOpen === idx ? null : idx)
//                             }
//                           >
//                             <span>{item.title}</span>
//                             <HiChevronDown
//                               className={`ml-2 h-5 w-5 transition-transform duration-300 ${
//                                 dropdownOpen === idx ? "rotate-180" : ""
//                               }`}
//                             />
//                           </button>
//                           <AnimatePresence>
//                             {dropdownOpen === idx && (
//                               <motion.div
//                                 variants={dropdownVariants}
//                                 initial="closed"
//                                 animate="open"
//                                 exit="closed"
//                                 className="overflow-hidden"
//                               >
//                                 {loading ? (
//                                   <div className="py-3 pl-4 sm:pl-6 text-gray-500 text-sm">
//                                     Loading courses...
//                                   </div>
//                                 ) : courses.length > 0 ? (
//                                   courses.map((course) => (
//                                     <motion.button
//                                       key={course._id}
//                                       className="flex items-start w-full py-2 sm:py-3 pl-4 sm:pl-6 text-gray-600 hover:text-primaryColor font-medium text-sm sm:text-base hover:bg-gray-50 rounded-xl transition-all duration-200 group"
//                                       onClick={() =>
//                                         handleNavigation(
//                                           `/courses/${slugify(
//                                             course?.category
//                                           )}`,
//                                           course._id
//                                         )
//                                       }
//                                       whileHover={{ x: 8 }}
//                                       whileTap={{ scale: 0.98 }}
//                                     >
//                                       <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 mt-1.5 group-hover:scale-125 transition-transform duration-200 flex-shrink-0"></span>
//                                       <span className="text-left break-words">
//                                         {course.category}
//                                       </span>
//                                     </motion.button>
//                                   ))
//                                 ) : (
//                                   <div className="py-3 pl-4 sm:pl-6 text-gray-500 text-sm">
//                                     No courses available
//                                   </div>
//                                 )}
//                               </motion.div>
//                             )}
//                           </AnimatePresence>
//                         </motion.div>
//                       ) : item.options ? (
//                         <motion.div
//                           key={idx}
//                           className="border-b border-gray-100 pb-2"
//                           variants={menuItemVariants}
//                         >
//                           <button
//                             className="flex justify-between items-center w-full py-3 sm:py-4 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 heading"
//                             onClick={() =>
//                               setDropdownOpen(dropdownOpen === idx ? null : idx)
//                             }
//                           >
//                             <span>{item.title}</span>
//                             <HiChevronDown
//                               className={`ml-2 h-5 w-5 transition-transform duration-300 ${
//                                 dropdownOpen === idx ? "rotate-180" : ""
//                               }`}
//                             />
//                           </button>
//                           <AnimatePresence>
//                             {dropdownOpen === idx && (
//                               <motion.div
//                                 variants={dropdownVariants}
//                                 initial="closed"
//                                 animate="open"
//                                 exit="closed"
//                                 className="overflow-hidden"
//                               >
//                                 {item.options.map((opt, i) => (
//                                   <motion.button
//                                     key={i}
//                                     className="flex items-center w-full py-2 sm:py-3 pl-4 sm:pl-6 text-gray-600 hover:text-primaryColor font-medium text-sm sm:text-base hover:bg-gray-50 rounded-xl transition-all duration-200 group sub-heading"
//                                     onClick={() => handleNavigation(opt.path)}
//                                     whileHover={{ x: 8 }}
//                                     whileTap={{ scale: 0.98 }}
//                                   >
//                                     <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 group-hover:scale-125 transition-transform duration-200"></span>
//                                     {opt.title}
//                                   </motion.button>
//                                 ))}
//                               </motion.div>
//                             )}
//                           </AnimatePresence>
//                         </motion.div>
//                       ) : (
//                         <motion.button
//                           key={idx}
//                           className="flex items-center w-full py-3 sm:py-4  sm:pl-2 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 border-b border-gray-100 hover:bg-gray-50 rounded-lg heading"
//                           onClick={() => handleNavigation(item.path)}
//                           variants={menuItemVariants}
//                           whileHover={{ x: 8 }}
//                           whileTap={{ scale: 0.98 }}
//                         >
//                           <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-200"></span>
//                           {item.title}
//                         </motion.button>
//                       )
//                     )}

//                     {/* Mobile CTA Button */}
//                     <Link
//                       to="/apply-online"
//                       onClick={() => {
//                         window.scrollTo({ top: 0, behavior: "smooth" });
//                       }}
//                     >
//                       <motion.button
//                         className="mt-4 sm:mt-6 bg-gradient-to-r from-primaryColor to-secondaryColor text-white w-full py-3 sm:py-4 rounded-xl hover:shadow-lg font-semibold shadow-md text-sm sm:text-base heading"
//                         initial="closed"
//                         animate="open"
//                         exit="closed"
//                         onClick={() => setIsOpen(false)}
//                         variants={menuItemVariants}
//                         whileHover={{
//                           scale: 1.02,
//                           y: -2,
//                         }}
//                         whileTap={{ scale: 0.98 }}
//                       >
//                         Apply Online
//                       </motion.button>
//                     </Link>
//                   </motion.div>
//                 </div>
//               </motion.div>
//             </>
//           )}
//         </AnimatePresence>
//       </nav>
//     </div>
//   );
// };

// export default UserNavbar;

import { useState, useEffect } from "react";
import { HiMenu, HiX, HiChevronDown, HiChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import logo from "../../Assets/Logos/insd-logo.png";
import { Link } from "react-router-dom";
import DemoRegistrationTab from "../common/DemoRegistrationTab";
import DemoClassRegistrationModal from "./DemoClassRegistrationModal";

const UserNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [desktopDropdown, setDesktopDropdown] = useState(null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [upcomingCourses, setUpcomingCourses] = useState([]);
  const [upcomingLoading, setUpcomingLoading] = useState(true);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/courses/get-all`,
        );

        if (response.data.success) {
          const apiCourses = response.data.data.map((course) => ({
            ...course,
            isStatic: false,
          }));

          setCourses(apiCourses);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchUpcomingCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/upcoming-courses/active`,
        );

        if (response.data.success) {
          setUpcomingCourses(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching upcoming courses:", error);
        setUpcomingCourses([]);
      } finally {
        setUpcomingLoading(false);
      }
    };

    fetchUpcomingCourses();
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const navItems = [
    {
      title: "Home",
      path: "/",
    },
    {
      title: "About",
      path: "/about",
    },
    {
      title: "Courses",
      isCourseDropdown: true,
      isLoading: loading,
    },
    {
      title: "Explore",
      options: [
        {
          title: "Events",
          path: "/events",
        },
        {
          title: "Student Portfolios",
          path: "/student-portfolio",
        },
      ],
    },
    {
      title: "Updates",
      options: [
        {
          title: "Gallery",
          path: "/gallery",
        },
        {
          title: "Blog & News",
          path: "/blog",
        },
      ],
    },
    {
      title: "Contact",
      path: "/contact",
    },
  ];

  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");

  const handleCourseNavigation = (course) => {
    navigate(`/courses/${slugify(course.category)}`, {
      state: {
        courseId: course._id,
      },
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setIsOpen(false);
    setDropdownOpen(null);
    setDesktopDropdown(null);
  };

  const handleUpcomingCourseNavigation = (course) => {
    navigate(`/upcoming-courses/${slugify(course.name)}`, {
      state: {
        courseId: course._id,
        courseName: course.name,
      },
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setIsOpen(false);
    setDropdownOpen(null);
    setDesktopDropdown(null);
  };

  // ============================================================
  // GENERAL NAVIGATION
  // ============================================================
  const handleNavigation = (path, courseId = null) => {
    if (courseId) {
      navigate(path, {
        state: {
          courseId,
        },
      });
    } else {
      navigate(path);
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setIsOpen(false);
    setDropdownOpen(null);
    setDesktopDropdown(null);
  };

  const sidebarVariants = {
    closed: {
      x: "-100%",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
        duration: 0.3,
      },
    },
    open: {
      x: 0,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
        duration: 0.3,
      },
    },
  };

  const backdropVariants = {
    closed: {
      opacity: 0,
      transition: {
        duration: 0.2,
      },
    },
    open: {
      opacity: 1,
      transition: {
        duration: 0.2,
      },
    },
  };

  const menuItemVariants = {
    closed: {
      opacity: 0,
      x: -20,
      transition: {
        duration: 0.2,
      },
    },
    open: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const dropdownVariants = {
    closed: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.2,
      },
    },
    open: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.3,
      },
    },
  };

  const staggerContainer = {
    open: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
    closed: {
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  };

  return (
    <div className="sticky top-0 w-full z-50">
      <nav className="bg-white shadow-lg w-full border-b border-gray-100 tracking-wide">
        <div className="py-2 px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-18 md:h-20">
            <motion.div
              className="flex-shrink-0 cursor-pointer transform hover:scale-105 transition-transform duration-200"
              onClick={() => navigate("/")}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img
                src={logo}
                alt="Logo"
                className="h-12 w-auto sm:h-14 md:h-16 lg:h-20 drop-shadow-sm"
              />
            </motion.div>

            <div className="hidden lg:flex items-center space-x-1 xl:space-x-2">
              {navItems.map((item, idx) =>
                item.options ? (
                  <div
                    key={idx}
                    className="relative"
                    onMouseEnter={() => setDesktopDropdown(idx)}
                    onMouseLeave={() => setDesktopDropdown(null)}
                  >
                    <motion.button
                      className="flex items-center px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="relative whitespace-nowrap">
                        {item.title}

                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
                      </span>

                      <HiChevronDown
                        className={`ml-1 h-4 w-4 transition-transform duration-300 ${
                          desktopDropdown === idx ? "rotate-180" : ""
                        }`}
                      />
                    </motion.button>

                    <AnimatePresence>
                      {desktopDropdown === idx && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            y: -10,
                            scale: 0.95,
                          }}
                          animate={{
                            opacity: 1,
                            y: 0,
                            scale: 1,
                          }}
                          exit={{
                            opacity: 0,
                            y: -10,
                            scale: 0.95,
                          }}
                          transition={{ duration: 0.2 }}
                          className="absolute top-full left-0 bg-white shadow-xl rounded-2xl mt-2 border border-gray-100 min-w-[200px] xl:min-w-[240px] z-20"
                        >
                          <div className="p-2 xl:p-3">
                            {item.options.length > 0 ? (
                              item.options.map((opt, i) => (
                                <motion.button
                                  key={i}
                                  onClick={() => handleNavigation(opt.path)}
                                  className="flex justify-between items-center w-full text-left px-3 xl:px-4 py-2 xl:py-3 text-sm xl:text-base text-gray-600 hover:bg-primaryColor/5 hover:text-primaryColor rounded-xl transition-all duration-200 group"
                                  whileHover={{ x: 4 }}
                                  whileTap={{ scale: 0.98 }}
                                >
                                  <span className="flex items-center font-medium whitespace-nowrap">
                                    <span className="w-2 h-2 bg-primaryColor rounded-full mr-2 xl:mr-3 group-hover:scale-125 transition-transform duration-200"></span>

                                    {opt.title}
                                  </span>

                                  <HiChevronRight className="h-4 w-4 text-gray-400 group-hover:text-primaryColor group-hover:translate-x-1 transition-all duration-200" />
                                </motion.button>
                              ))
                            ) : (
                              <div className="px-4 py-3 text-gray-500 text-center text-sm">
                                No options available
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ) : item.isCourseDropdown ? (
                  <div
                    key={idx}
                    className="relative"
                    onMouseEnter={() => setDesktopDropdown(idx)}
                    onMouseLeave={() => setDesktopDropdown(null)}
                  >
                    <motion.button
                      className="flex items-center px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <span className="relative whitespace-nowrap">
                        {item.title}

                        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
                      </span>

                      <HiChevronDown
                        className={`ml-1 h-4 w-4 transition-transform duration-300 ${
                          desktopDropdown === idx ? "rotate-180" : ""
                        }`}
                      />
                    </motion.button>

                    <AnimatePresence>
                      {desktopDropdown === idx && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            y: -10,
                            scale: 0.95,
                          }}
                          animate={{
                            opacity: 1,
                            y: 0,
                            scale: 1,
                          }}
                          exit={{
                            opacity: 0,
                            y: -10,
                            scale: 0.95,
                          }}
                          transition={{ duration: 0.2 }}
                          className="absolute top-full left-0 bg-white shadow-xl rounded-2xl mt-2 border border-gray-100 min-w-[240px] xl:min-w-[280px] z-20 max-h-[500px] overflow-y-auto hide-scrollbar"
                        >
                          <div className="p-2 xl:p-3">
                            {loading ? (
                              <div className="px-4 py-3 text-gray-500 text-center text-sm">
                                Loading courses...
                              </div>
                            ) : courses.length > 0 ? (
                              courses.map((course) => (
                                <motion.button
                                  key={course._id}
                                  onClick={() => handleCourseNavigation(course)}
                                  className="flex justify-between items-center w-full text-left px-3 xl:px-4 py-2 xl:py-3 text-gray-600 hover:bg-primaryColor/5 hover:text-primaryColor rounded-xl transition-all duration-200 group"
                                  whileHover={{ x: 4 }}
                                  whileTap={{ scale: 0.98 }}
                                >
                                  <span className="flex items-center font-medium">
                                    <span className="w-2 h-2 bg-primaryColor rounded-full mr-2 xl:mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-200"></span>

                                    <span className="text-xs xl:text-sm break-words">
                                      {course?.category}
                                    </span>
                                  </span>

                                  <HiChevronRight className="h-4 w-4 text-gray-400 group-hover:text-primaryColor group-hover:translate-x-1 transition-all duration-200 flex-shrink-0 ml-2" />
                                </motion.button>
                              ))
                            ) : (
                              <div className="px-4 py-3 text-gray-500 text-center text-sm">
                                No courses available
                              </div>
                            )}

                            {upcomingLoading ? (
                              <div className="px-4 py-3 text-gray-500 text-center text-sm">
                                Loading upcoming courses...
                              </div>
                            ) : upcomingCourses.length > 0 ? (
                              <>
                                {upcomingCourses.map((course) => (
                                  <motion.button
                                    key={course._id}
                                    onClick={() =>
                                      handleUpcomingCourseNavigation(course)
                                    }
                                    className="flex justify-between items-center w-full text-left px-3 xl:px-4 py-2 xl:py-3 text-gray-600 hover:bg-primaryColor/5 hover:text-primaryColor rounded-xl transition-all duration-200 group"
                                    whileHover={{ x: 4 }}
                                    whileTap={{ scale: 0.98 }}
                                  >
                                    <span className="flex items-center font-medium">
                                      <span className="w-2 h-2 bg-primaryColor rounded-full mr-2 xl:mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-200"></span>

                                      <span className="text-xs xl:text-sm break-words">
                                        {course?.name}
                                      </span>
                                    </span>

                                    <HiChevronRight className="h-4 w-4 text-gray-400 group-hover:text-primaryColor group-hover:translate-x-1 transition-all duration-200 flex-shrink-0 ml-2" />
                                  </motion.button>
                                ))}
                              </>
                            ) : null}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ) : (
                  <motion.button
                    key={idx}
                    className="relative px-2 xl:px-4 py-2 text-sm xl:text-base text-gray-700 hover:text-primaryColor font-semibold transition-colors duration-300 rounded-lg hover:bg-gray-50 group heading"
                    onClick={() => handleNavigation(item.path)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <span className="relative whitespace-nowrap">
                      {item.title}

                      <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primaryColor group-hover:w-full transition-all duration-300"></span>
                    </span>
                  </motion.button>
                ),
              )}
            </div>

            <div className="hidden lg:block">
              <motion.button
                className="bg-gradient-to-r from-primaryColor to-secondaryColor text-white px-4 xl:px-6 py-2 xl:py-3 rounded-xl hover:shadow-lg font-semibold shadow-md text-sm xl:text-base whitespace-nowrap heading"
                onClick={() => {
                  navigate("/apply-online");

                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
                whileHover={{
                  scale: 1.05,
                  y: -2,
                  transition: {
                    duration: 0.2,
                  },
                }}
                whileTap={{
                  scale: 0.95,
                }}
              >
                Apply Online
              </motion.button>
            </div>

            <div className="lg:hidden flex items-center">
              <motion.button
                onClick={() => setIsOpen(!isOpen)}
                className="focus:outline-none p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                {isOpen ? (
                  <HiX className="h-6 w-6 text-gray-700" />
                ) : (
                  <HiMenu className="h-6 w-6 text-gray-700" />
                )}
              </motion.button>
            </div>
          </div>
        </div>

        <AnimatePresence>
          {isOpen && (
            <>
              {/* Backdrop */}
              <motion.div
                key="backdrop"
                className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                variants={backdropVariants}
                initial="closed"
                animate="open"
                exit="closed"
                onClick={() => setIsOpen(false)}
              />

              <motion.div
                key="sidebar"
                className="lg:hidden fixed top-0 left-0 w-[85vw] max-w-[320px] sm:max-w-[360px] h-full bg-white shadow-2xl z-50 overflow-y-auto"
                variants={sidebarVariants}
                initial="closed"
                animate="open"
                exit="closed"
              >
                <div className="p-4 sm:p-6">
                  <div className="flex justify-end mb-6 sm:mb-8">
                    <motion.button
                      onClick={() => setIsOpen(false)}
                      className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      variants={menuItemVariants}
                    >
                      <HiX className="h-5 w-5 text-gray-600" />
                    </motion.button>
                  </div>

                  {/* Navigation Items */}
                  <motion.div
                    className="flex flex-col space-y-1 sm:space-y-2"
                    variants={staggerContainer}
                    initial="closed"
                    animate="open"
                    exit="closed"
                  >
                    {navItems.map((item, idx) =>
                      item.isCourseDropdown ? (
                        <motion.div
                          key={idx}
                          className="border-b border-gray-100 pb-2"
                          variants={menuItemVariants}
                        >
                          <button
                            className="flex justify-between items-center w-full py-3 sm:py-4 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 heading"
                            onClick={() =>
                              setDropdownOpen(dropdownOpen === idx ? null : idx)
                            }
                          >
                            <span>{item.title}</span>

                            <HiChevronDown
                              className={`ml-2 h-5 w-5 transition-transform duration-300 ${
                                dropdownOpen === idx ? "rotate-180" : ""
                              }`}
                            />
                          </button>

                          <AnimatePresence>
                            {dropdownOpen === idx && (
                              <motion.div
                                variants={dropdownVariants}
                                initial="closed"
                                animate="open"
                                exit="closed"
                                className="overflow-hidden"
                              >
                                {loading ? (
                                  <div className="py-3 pl-4 sm:pl-6 text-gray-500 text-sm">
                                    Loading courses...
                                  </div>
                                ) : courses.length > 0 ? (
                                  courses.map((course) => (
                                    <motion.button
                                      key={course._id}
                                      className="flex items-start w-full py-2 sm:py-3 pl-4 sm:pl-6 text-gray-600 hover:text-primaryColor font-medium text-sm sm:text-base hover:bg-gray-50 rounded-xl transition-all duration-200 group"
                                      onClick={() =>
                                        handleCourseNavigation(course)
                                      }
                                      whileHover={{ x: 8 }}
                                      whileTap={{ scale: 0.98 }}
                                    >
                                      <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 mt-1.5 group-hover:scale-125 transition-transform duration-200 flex-shrink-0"></span>

                                      <span className="text-left break-words">
                                        {course.category}
                                      </span>

                                      <HiChevronRight className="h-4 w-4 ml-auto mr-2 mt-0.5 text-gray-400 group-hover:text-primaryColor flex-shrink-0" />
                                    </motion.button>
                                  ))
                                ) : (
                                  <div className="py-3 pl-4 sm:pl-6 text-gray-500 text-sm">
                                    No courses available
                                  </div>
                                )}

                                {upcomingLoading ? (
                                  <div className="py-3 pl-4 sm:pl-6 text-gray-500 text-sm">
                                    Loading upcoming courses...
                                  </div>
                                ) : upcomingCourses.length > 0 ? (
                                  <>
                                    {upcomingCourses.map((course) => (
                                      <motion.button
                                        key={course._id}
                                        className="flex items-start w-full py-2 sm:py-3 pl-4 sm:pl-6 text-gray-600 hover:text-primaryColor font-medium text-sm sm:text-base hover:bg-gray-50 rounded-xl transition-all duration-200 group"
                                        onClick={() =>
                                          handleUpcomingCourseNavigation(course)
                                        }
                                        whileHover={{ x: 8 }}
                                        whileTap={{ scale: 0.98 }}
                                      >
                                        <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 mt-1.5 group-hover:scale-125 transition-transform duration-200 flex-shrink-0"></span>

                                        <span className="text-left break-words">
                                          {course.name}
                                        </span>

                                        <HiChevronRight className="h-4 w-4 ml-auto mr-2 mt-0.5 text-gray-400 group-hover:text-primaryColor flex-shrink-0" />
                                      </motion.button>
                                    ))}
                                  </>
                                ) : null}
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </motion.div>
                      ) : item.options ? (
                        <motion.div
                          key={idx}
                          className="border-b border-gray-100 pb-2"
                          variants={menuItemVariants}
                        >
                          <button
                            className="flex justify-between items-center w-full py-3 sm:py-4 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 heading"
                            onClick={() =>
                              setDropdownOpen(dropdownOpen === idx ? null : idx)
                            }
                          >
                            <span>{item.title}</span>

                            <HiChevronDown
                              className={`ml-2 h-5 w-5 transition-transform duration-300 ${
                                dropdownOpen === idx ? "rotate-180" : ""
                              }`}
                            />
                          </button>

                          <AnimatePresence>
                            {dropdownOpen === idx && (
                              <motion.div
                                variants={dropdownVariants}
                                initial="closed"
                                animate="open"
                                exit="closed"
                                className="overflow-hidden"
                              >
                                {item.options.map((opt, i) => (
                                  <motion.button
                                    key={i}
                                    className="flex items-center w-full py-2 sm:py-3 pl-4 sm:pl-6 text-gray-600 hover:text-primaryColor font-medium text-sm sm:text-base hover:bg-gray-50 rounded-xl transition-all duration-200 group sub-heading"
                                    onClick={() => handleNavigation(opt.path)}
                                    whileHover={{ x: 8 }}
                                    whileTap={{ scale: 0.98 }}
                                  >
                                    <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 group-hover:scale-125 transition-transform duration-200"></span>

                                    {opt.title}
                                  </motion.button>
                                ))}
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </motion.div>
                      ) : (
                        <motion.button
                          key={idx}
                          className="flex items-center w-full py-3 sm:py-4 sm:pl-2 text-gray-800 font-semibold text-base sm:text-lg hover:text-primaryColor transition-colors duration-200 border-b border-gray-100 hover:bg-gray-50 rounded-lg heading"
                          onClick={() => handleNavigation(item.path)}
                          variants={menuItemVariants}
                          whileHover={{ x: 8 }}
                          whileTap={{ scale: 0.98 }}
                        >
                          <span className="w-1.5 h-1.5 bg-primaryColor rounded-full mr-2 sm:mr-3 flex-shrink-0"></span>

                          {item.title}
                        </motion.button>
                      ),
                    )}

                    <Link
                      to="/apply-online"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <motion.button
                        className="mt-4 sm:mt-6 bg-gradient-to-r from-primaryColor to-secondaryColor text-white w-full py-3 sm:py-4 rounded-xl hover:shadow-lg font-semibold shadow-md text-sm sm:text-base heading"
                        initial="closed"
                        animate="open"
                        exit="closed"
                        onClick={() => setIsOpen(false)}
                        variants={menuItemVariants}
                        whileHover={{
                          scale: 1.02,
                          y: -2,
                        }}
                        whileTap={{
                          scale: 0.98,
                        }}
                      >
                        Apply Online
                      </motion.button>
                    </Link>
                  </motion.div>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </nav>
      <DemoRegistrationTab onClick={() => setIsDemoModalOpen(true)} />

      <DemoClassRegistrationModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />
    </div>
  );
};

export default UserNavbar;
